import { describeApiError } from './stockErrorUtils';

export const applyProductSaleSave = async ({ save, sale, onRecorded, onError, t }) => {
  try {
    await save(sale);
    onRecorded();
  } catch (error) {
    onError(describeApiError(error, t, 'productsManagement.error.createSale'));
  }
};
